// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "2c386607" + "." + "fdcd7c6fe7d43f0b" + ".js";
};